import { render, staticRenderFns } from "./ItemGroupV2.vue?vue&type=template&id=76c38145&scoped=true"
import script from "./ItemGroupV2.vue?vue&type=script&lang=js"
export * from "./ItemGroupV2.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupV2.vue?vue&type=style&index=0&id=76c38145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c38145",
  null
  
)

export default component.exports